export default __webpack_public_path__ + "static/media/Malware bytes.c296da39.png";